import { ThunkDispatch } from 'redux-thunk';
import { CpMessageFilter } from '../interface/cpPanel.interface';

import { Action } from 'redux';
import { BalanceState } from 'shared/interface';
import * as actionTypes from 'shared/store/action-types';
import { createAction, setBalanceDetails } from 'shared/util/utility';
import { MAIN_BALANCE } from '../../../shared/constants/common';
import { MessageData } from '../cpMessages/interface/interface';

export const setFilter = (filter: CpMessageFilter) => {
	return async (dispatch: ThunkDispatch<{}, {}, any>) => {
		try {
			dispatch(createAction(actionTypes.FETCH_MESSAGES_INIT));
			dispatch(
				createAction(actionTypes.FETCH_MESSAGES_SUCCESS, {
					filter,
				}),
			);
		} catch (err) {
			dispatch(createAction(actionTypes.FETCH_MESSAGES_FAIL));
		}
	};
};

export const setMessagesAmountToDelete = (toDeleteCount: number) => {
	return async (dispatch: ThunkDispatch<{}, {}, any>) => {
		dispatch(createAction(actionTypes.SET_MESSAGES_COUNT_SUCCESS, toDeleteCount));
	};
};

export const handleBalanceData = (balanceData: BalanceState) => {
	// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
	return async (dispatch: ThunkDispatch<Record<string, unknown>, Record<string, unknown>, Action>) => {
		dispatch(createAction(actionTypes.BALANCE_DATA, balanceData));
		setBalanceDetails(balanceData);
	};
};

export const clearBalanceData = () =>
	handleBalanceData({
		selectedBalanceType: MAIN_BALANCE,
		mainBalance: null,
		bonusBalance: null,
		bonusBalanceList: [],
		depositCounter: null,
	});

export const fetchMessagesListAction = (messagesList: MessageData[]) => {
	return async (dispatch: ThunkDispatch<Record<string, unknown>, Record<string, unknown>, Action>) => {
		try {
			dispatch(createAction(actionTypes.FETCH_MESSAGES_LIST_INIT));
			dispatch(createAction(actionTypes.FETCH_MESSAGES_LIST_SUCCESS, messagesList));
		} catch (err) {
			dispatch(createAction(actionTypes.FETCH_MESSAGES_LIST_FAIL));
		}
	};
};
